// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

$(() => {
  const sideContentRecommend = document.querySelector('.side-contents--recommend');
  if (sideContentRecommend) {
    $.ajax({
      url: `/recommends?type=user&id=side_content_item_recommend&data_type=${sideContentRecommend.dataset.type}`,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      type: 'GET',
      timeout: 5000,
    });
  }

  const sideContentAiRecommend = document.querySelector('.side-contents--ai');
  if (sideContentAiRecommend) {
    $.ajax({
      url: '/recommends?type=ai&id=side_content_ai_recommend',
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      type: 'GET',
      timeout: 5000,
    });
  }
});
